import React from 'react';

import {Enzyme} from 'molbio/enzymes/backbone/Enzymes';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface EnzymeRowProps {
  enzyme: Enzyme;
}

function EnzymeRow({enzyme}: EnzymeRowProps): JSX.Element {
  return <td className="mono">{enzyme.name()}</td>;
}

export default makeDeprecatedJadeStyleTemplate<EnzymeRowProps>(EnzymeRow);
